import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/taggedTemplateLiteralLoose";
var _excluded = ["children"];
var _templateObject;
import styled from 'styled-components';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var Label = styled.label(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  font-family: monospace;\n  input {\n    vertical-align: middle;\n    margin-right: 6px;\n  }\n  input:disabled {\n    cursor: not-allowed;\n    color: var(--color-fg-subtle);\n  }\n  > span * {\n    vertical-align: middle;\n  }\n"])));
export var CheckboxOption = _ref => {
  var children = _ref.children,
    other = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Label, {
    children: /*#__PURE__*/_jsxs("span", {
      children: [/*#__PURE__*/_jsx("input", _extends({
        type: "checkbox"
      }, other)), /*#__PURE__*/_jsx("span", {
        children: children
      })]
    })
  });
};